import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-kbin', 'BrandKbin', [["g",{"stroke-width":"1.838","key":"svg-0"}]]);